var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var $ = require("./lib/qsa");

// Global vars
var quiz = null;
var pymChild = null;

let slides;
let currentSlide;
let questionSlides;

let counts = null;
let score = 0;

console.clear();

/*
 * Initialize the graphic.
 */
var onWindowLoaded = function() {
  // Setup handlers
  document.querySelectorAll("button.reset").forEach(button => {
    button.addEventListener("click", resetQuiz)
  })
  document.querySelectorAll("button.start").forEach(button => {
    button.addEventListener("click", goForward)
  })
  slides = document.querySelectorAll(".slide");
  questionSlides = document.querySelectorAll(".slide--question");
  questionSlides.forEach((question, idx) => {
    let numberButtons = [...question.querySelectorAll(".bittersweet-level__number")]
    let nextButton = question.querySelector('.next')
    numberButtons.forEach(button => {
      let forAttr = button.getAttribute("for")
      let correspondingInput = question.querySelector(`#${forAttr}`)

      button.addEventListener("click", () => {
        correspondingInput.checked = true
        goForward();

        // nextButton.classList.remove("is-opacity-0")
        // var event = new Event('change');
        // correspondingInput.dispatchEvent(event);
      })
    })
    
    
    
    let radioButtons = [...question.querySelectorAll(`[name='bittersweet-level-${idx+1}']`)]
    radioButtons.forEach(button => {
      // console.log(button.checked)
      button.addEventListener("change", () => {
        nextButton.classList.remove("is-opacity-0")
        // var event = new Event('change');
        // correspondingInput.dispatchEvent(event);
        // if (button.checked) {
        //   console.log("")
        // } else {
        //   console.log("ya")
        // }
      })
    })

    question.querySelectorAll("button.next").forEach(button => {
      button.addEventListener("click", () => {
        // Check if a radio button option has been selected
        let optionSelected = radioButtons.some(rButton => rButton.checked)

        if (optionSelected) {
          goForward();
        }
      })
    })
  })
  resetQuiz();
}

function resetQuiz() {
  currentSlide = 0;
  score = 0;

  questionSlides.forEach((question, idx) => {
    question.querySelectorAll(`[name='bittersweet-level-${idx+1}']`).forEach(rButton => {
      rButton.checked = false;
    }) 
    question.querySelectorAll("button.next").forEach(button => {
      button.classList.add("is-opacity-0")
    })
  })

  updateCurrentSlideDisplay();
  updateScoreDisplay();
}

function goForward() {
  if (currentSlide < (slides.length - 1)) {
    currentSlide += 1;
    updateCurrentSlideDisplay();
  }

  if (currentSlide === (slides.length - 1)) {
    tallyScore();
    updateScoreDisplay();
    return;
  }
}

function updateCurrentSlideDisplay() {
  slides.forEach((slide, idx) => {
    if (idx === currentSlide) {
      slide.classList.add("current")
    } else {
      slide.classList.remove("current")
    }
  })
}

function updateScoreDisplay() {
  let scoreEl = document.querySelector('.result--score');
  let scoreVal = score / (questionSlides.length || 1)
  let roundedScore = Math.round(scoreVal * 10) / 10;

  scoreEl.innerHTML = roundedScore;

  let bittersweetLevel;
  if (scoreVal <= 3.8) {
    bittersweetLevel = 'sanguine'
  } else if (scoreVal > 3.8 && scoreVal <= 5.7) {
    bittersweetLevel = 'both'
  } else {
    bittersweetLevel = 'bittersweet'
  }

  let bittersweetLevelEls = document.querySelectorAll('.description.bittersweet-level')
  bittersweetLevelEls.forEach(el => {
    el.classList.remove('is-display-none')
    if (el.dataset.bittersweetlevel != bittersweetLevel) {
      el.classList.add('is-display-none')
    }
  })
}

function tallyScore() {
  questionSlides.forEach((question, idx) => {
    question.querySelectorAll(`[name='bittersweet-level-${idx+1}']`).forEach(rButton => {
      if (rButton.checked) {
        score += parseFloat(rButton.value)
      }
    }) 
  })
  // console.log(score)
}

/*
 * Initially load the graphic
 * (NB: Use window.load to ensure all images have loaded)
 */
window.onload = onWindowLoaded;